import { Eye, EyeOff } from "lucide-react";
import React, { useState } from "react";

type PasswordInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

/**
 * Password field with a show/hide toggle. Takes the same props as a plain <input>;
 * `className` styles the input itself so callers keep control of the field's look.
 */
function PasswordInput({ className = "", ...inputProps }: PasswordInputProps) {
	const [visible, setVisible] = useState(false);

	return (
		<div className="relative w-full">
			<input {...inputProps} type={visible ? "text" : "password"} className={`w-full pr-9 ${className}`} />
			<button
				type="button"
				onClick={() => setVisible((prev) => !prev)}
				className="absolute right-0 top-0 flex h-full w-9 items-center justify-center text-gray-400 hover:text-gray-600"
				aria-label={visible ? "Hide password" : "Show password"}
				aria-pressed={visible}
			>
				{visible ? <EyeOff size={16} /> : <Eye size={16} />}
			</button>
		</div>
	);
}

export default PasswordInput;
